import type { ListItemDetail } from './domain';

// Issue #3: Positionen (Einkaufsmodus und Listenbearbeitung) sichtbar nach Kategorie
// gruppieren - die Liste kommt vom Backend bereits nach Filial-/Standard-
// Kategorienreihenfolge sortiert (getListDetail), gleiche Kategorien liegen
// also immer schon hintereinander.
export function groupByCategory(items: ListItemDetail[]) {
  const groups: { key: string; name: string; items: ListItemDetail[] }[] = [];
  for (const item of items) {
    // Sammelprodukte tragen ihre Kategorie selbst (wie Produkte).
    const category = item.product ? item.product.category : item.aggregate?.category;
    const key = category?.id ?? 'none';
    const name = category?.name ?? 'Ohne Kategorie';
    const last = groups[groups.length - 1];
    if (last && last.key === key) {
      last.items.push(item);
    } else {
      groups.push({ key, name, items: [item] });
    }
  }
  return groups;
}
